// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;1,100&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
}

.cont {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.login-cont-cel {
  background-image: url('Textura-ventana-de-inicio.png');
  display: flex;
  justify-content: center;
  align-items: center;
}

ion-card {
  background: #fdfdfd;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}
ion-card .where {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
ion-card .where a {
  font-size: 1rem;
  font-family: "Roboto", sans-serif;
  text-decoration: none;
  font-weight: 600;
  color: #000;
}
ion-card .where a span {
  display: inline-block;
  border-bottom: 3px solid #14A8CD;
  padding-bottom: 0.5rem;
}
ion-card .where #regis {
  font-weight: 600;
  color: #14A8CD;
  cursor: pointer;
}
ion-card img {
  width: 60%;
  padding: 1rem;
}
ion-card form {
  width: 100%;
  height: auto;
}
ion-card .error {
  color: red;
  font-size: 1rem;
  font-weight: bolder;
}
ion-card .correcto {
  color: green;
  font-size: 1rem;
  font-weight: bolder;
}
ion-card ion-item {
  --ion-item-background: none !important;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;
}
ion-card ion-button {
  height: 4rem;
  font-family: "Roboto", sans-serif;
  font-size: 1.3rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  --background: #14A8CD;
  color: #fff;
}
ion-card ion-button:hover {
  --background: #14A8CD!important;
  color: #fff;
  transition: 1s;
}
ion-card ion-input {
  color: #000;
  font-weight: 600;
}
ion-card ion-label {
  color: #000;
  font-weight: 600;
}
ion-card .item-has-focus .label-floating.sc-ion-label-md-h:not(.ion-color) {
  color: #000;
}
ion-card .item-interactive.item-has-focus {
  --highlight-background: #000;
}
ion-card .forgot {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
ion-card .forgot a {
  font-size: 1rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  color: #000;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.mod {
  --background: black;
}

#closeModal {
  font-size: 1.2rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  color: #000;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.loginDesk {
  width: 100%;
  height: auto;
  display: none;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.loginDesk .contDesk {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  background-color: #fff;
  padding: 5em 0em;
}
.loginDesk .contDesk .cardi {
  background: #fdfdfd;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 25em;
  height: auto;
  border-radius: 1em;
  box-shadow: rgba(0, 168, 203, 0.3) 0px 5px 30px;
}
.loginDesk .contDesk .cardi .where {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin: 0.5em 0em;
}
.loginDesk .contDesk .cardi .where a {
  font-size: 0.9em;
  font-family: "Roboto", sans-serif;
  text-decoration: none;
  font-weight: 400;
  color: #000;
}
.loginDesk .contDesk .cardi .where a span {
  display: inline-block;
  border-bottom: 3px solid #14A8CD;
  padding-bottom: 0.5rem;
}
.loginDesk .contDesk .cardi .where #regis {
  font-weight: 400;
  color: #14A8CD;
  cursor: pointer;
}
.loginDesk .contDesk .cardi img {
  width: 12em;
  padding: 1em;
}
.loginDesk .contDesk .cardi form {
  width: 100%;
  height: auto;
}
.loginDesk .contDesk .cardi .error {
  color: red;
  font-size: 1em;
  font-weight: bolder;
}
.loginDesk .contDesk .cardi .correcto {
  color: green;
  font-size: 1em;
  font-weight: bolder;
}
.loginDesk .contDesk .cardi ion-item {
  --ion-item-background: none !important;
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin: 1em 0em;
}
.loginDesk .contDesk .cardi ion-button {
  height: 4em;
  font-family: "Roboto", sans-serif;
  font-size: 1em;
  letter-spacing: 0.1rem;
  font-weight: 400;
  --background: #14A8CD;
  color: #fff;
}
.loginDesk .contDesk .cardi ion-button:hover {
  --background: #14A8CD!important;
  color: #fff;
  transition: 1s;
}
.loginDesk .contDesk .cardi ion-input {
  color: #000;
  font-weight: 400;
}
.loginDesk .contDesk .cardi ion-label {
  color: #000;
  font-weight: 400;
  font-size: 0.8em;
}
.loginDesk .contDesk .cardi .item-has-focus .label-floating.sc-ion-label-md-h:not(.ion-color) {
  color: #000;
}
.loginDesk .contDesk .cardi .item-interactive.item-has-focus {
  --highlight-background: #000;
}
.loginDesk .contDesk .cardi .forgot {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loginDesk .contDesk .cardi .forgot a {
  font-size: 0.9em;
  color: #000;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin: 1.5em 0em;
  transition: 0.4s all ease-in-out;
}
.loginDesk .contDesk .cardi .forgot a:hover {
  color: #14A8CD;
}

.loginDesk::-webkit-scrollbar {
  width: 0.35em;
  background-color: transparent;
  height: 0.7em;
}

.loginDesk::-webkit-scrollbar-thumb {
  background-color: rgba(0, 162, 199, 0.4745098039);
  width: 0.25em;
}

@media (min-width: 992px) {
  .loginDesk {
    display: flex;
  }
  .login-cont-cel {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login/login.page.scss"],"names":[],"mappings":"AAGA;EACI,UAAA;EACA,SAAA;AADJ;;AAIA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AADJ;;AAIA;EACI,sDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uLAAA;AADJ;AAGI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AADR;AAGQ;EACI,eAAA;EACA,iCAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AADZ;AAGY;EACI,qBAAA;EACA,gCAAA;EACA,sBAAA;AADhB;AAKQ;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AAHZ;AAOI;EACI,UAAA;EACA,aAAA;AALR;AAQI;EACI,WAAA;EACA,YAAA;AANR;AASI;EACI,UAAA;EACA,eAAA;EACA,mBAAA;AAPR;AAUI;EACI,YAAA;EACA,eAAA;EACA,mBAAA;AARR;AAWI;EACI,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AATR;AAYI;EACI,YAAA;EACA,iCAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AAVR;AAaI;EACI,+BAAA;EACA,WAAA;EACA,cAAA;AAXR;AAcI;EACI,WAAA;EACA,gBAAA;AAZR;AAeI;EACI,WAAA;EACA,gBAAA;AAbR;AAgBI;EACI,WAAA;AAdR;AAiBI;EACI,4BAAA;AAfR;AAkBI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBR;AAkBQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAhBZ;;AAqBA;EACI,mBAAA;AAlBJ;;AAqBA;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAlBJ;;AAqBA;EACI,WAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AAnBJ;AAqBI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAnBR;AAqBQ;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+CAAA;AAnBZ;AAsBY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AApBhB;AAsBgB;EACI,gBAAA;EACA,iCAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AApBpB;AAsBoB;EACI,qBAAA;EACA,gCAAA;EACA,sBAAA;AApBxB;AAwBgB;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AAtBpB;AA0BY;EACI,WAAA;EACA,YAAA;AAxBhB;AA2BY;EACI,WAAA;EACA,YAAA;AAzBhB;AA4BY;EACI,UAAA;EACA,cAAA;EACA,mBAAA;AA1BhB;AA6BY;EACI,YAAA;EACA,cAAA;EACA,mBAAA;AA3BhB;AA8BY;EACI,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA5BhB;AA+BY;EACI,WAAA;EACA,iCAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AA7BhB;AAgCY;EACI,+BAAA;EACA,WAAA;EACA,cAAA;AA9BhB;AAiCY;EACI,WAAA;EACA,gBAAA;AA/BhB;AAkCY;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAhChB;AAmCY;EACI,WAAA;AAjChB;AAoCY;EACI,4BAAA;AAlChB;AAqCY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnChB;AAqCgB;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;AAnCpB;AAsCgB;EACI,cAAA;AApCpB;;AA2CA;EACI,aAAA;EACA,6BAAA;EACA,aAAA;AAxCJ;;AA2CA;EACI,iDAAA;EAEA,aAAA;AAzCJ;;AA4CA;EACI;IACI,aAAA;EAzCN;EA4CE;IACI,aAAA;EA1CN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;1,100&display=swap');\r\n\r\n\r\n*{\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.cont{ \r\n    width: 100%;\r\n    min-height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 1rem;\r\n}\r\n\r\n.login-cont-cel{\r\n    background-image: url('../../../assets/img/Textura-ventana-de-inicio.png'); //rgb(189, 193, 194) !important\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\nion-card{\r\n    background: #fdfdfd;//     #fdfdfd            #14A8CD\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n    \r\n    .where{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: space-around;\r\n        align-items: center;\r\n        flex-direction: row;\r\n        margin-top: 2rem;\r\n        margin-bottom: 1rem;\r\n\r\n        a{\r\n            font-size: 1rem;\r\n            font-family: 'Roboto', sans-serif;\r\n            text-decoration: none;\r\n            font-weight: 600;\r\n            color: #000;\r\n\r\n            span{\r\n                display:inline-block;\r\n                border-bottom: 3px solid #14A8CD;\r\n                padding-bottom: .5rem;\r\n            }\r\n        }\r\n\r\n        #regis{\r\n            font-weight: 600;\r\n            color: #14A8CD;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    img{\r\n        width: 60%;\r\n        padding: 1rem;\r\n    }\r\n\r\n    form{\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    .error{\r\n        color: red;\r\n        font-size: 1rem;\r\n        font-weight: bolder;\r\n    }\r\n\r\n    .correcto{\r\n        color: green;\r\n        font-size: 1rem;\r\n        font-weight: bolder;\r\n    }\r\n\r\n    ion-item{\r\n        --ion-item-background: none !important;\r\n        margin-top: 2rem;\r\n        margin-bottom: 2rem;\r\n        padding-left: 2rem;\r\n        padding-right: 2rem;\r\n    }\r\n\r\n    ion-button{\r\n        height: 4rem;\r\n        font-family: 'Roboto', sans-serif;\r\n        font-size: 1.3rem;\r\n        letter-spacing: .1rem;\r\n        font-weight: 600;\r\n        --background: #14A8CD;\r\n        color: #fff;\r\n    }\r\n\r\n    ion-button:hover{\r\n        --background: #14A8CD!important;\r\n        color: #fff;\r\n        transition: 1s;\r\n    }\r\n\r\n    ion-input{\r\n        color: #000;\r\n        font-weight: 600;\r\n    }\r\n\r\n    ion-label{\r\n        color: #000;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .item-has-focus .label-floating.sc-ion-label-md-h:not(.ion-color){\r\n        color: #000;\r\n    }\r\n\r\n    .item-interactive.item-has-focus{\r\n        --highlight-background: #000;\r\n    }\r\n\r\n    .forgot{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        a{\r\n            font-size: 1rem;\r\n            margin-top: 2rem;\r\n            margin-bottom: 2rem;\r\n            color: #000;\r\n            font-weight: 600;\r\n            text-decoration: none;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n\r\n.mod{\r\n    --background: black;\r\n}\r\n\r\n#closeModal{\r\n    font-size: 1.2rem;\r\n    margin-top: 2rem;\r\n    margin-bottom: 2rem;\r\n    color: #000;\r\n    font-weight: 600;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.loginDesk{\r\n    width: 100%;\r\n    height: auto;\r\n    //overflow-y: scroll;\r\n    display: none;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n\r\n    .contDesk{ \r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        padding: 1rem;\r\n        background-color: #fff;\r\n        padding: 5em 0em;\r\n\r\n        .cardi{\r\n            background: #fdfdfd;//     #fdfdfd            #14A8CD\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            flex-direction: column;\r\n            width: 25em;\r\n            height: auto;\r\n            border-radius: 1em;\r\n            box-shadow: rgba(0, 168, 203, 0.3) 0px 5px 30px;\r\n            //box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n            \r\n            .where{\r\n                width: 100%;\r\n                height: auto;\r\n                display: flex;\r\n                justify-content: space-around;\r\n                align-items: center;\r\n                flex-direction: row;\r\n                margin-top: 0rem;\r\n                margin-bottom: 0rem;\r\n                margin: .5em 0em;\r\n\r\n                a{\r\n                    font-size: .9em;\r\n                    font-family: 'Roboto', sans-serif;\r\n                    text-decoration: none;\r\n                    font-weight: 400;\r\n                    color: #000;\r\n\r\n                    span{\r\n                        display:inline-block;\r\n                        border-bottom: 3px solid #14A8CD;\r\n                        padding-bottom: .5rem;\r\n                    }\r\n                }\r\n\r\n                #regis{\r\n                    font-weight: 400;\r\n                    color: #14A8CD;\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n\r\n            img{\r\n                width: 12em;\r\n                padding: 1em;\r\n            }\r\n\r\n            form{\r\n                width: 100%;\r\n                height: auto;\r\n            }\r\n\r\n            .error{\r\n                color: red;\r\n                font-size: 1em;\r\n                font-weight: bolder;\r\n            }\r\n\r\n            .correcto{\r\n                color: green;\r\n                font-size: 1em;\r\n                font-weight: bolder;\r\n            }\r\n\r\n            ion-item{\r\n                --ion-item-background: none !important;\r\n                margin-top: 0rem;\r\n                margin-bottom: 0rem;\r\n                margin: 1em 0em;\r\n            }\r\n\r\n            ion-button{\r\n                height: 4em;\r\n                font-family: 'Roboto', sans-serif;\r\n                font-size: 1em;\r\n                letter-spacing: .1rem;\r\n                font-weight: 400;\r\n                --background: #14A8CD;\r\n                color: #fff;\r\n            }\r\n\r\n            ion-button:hover{\r\n                --background: #14A8CD!important;\r\n                color: #fff;\r\n                transition: 1s;\r\n            }\r\n\r\n            ion-input{\r\n                color: #000;\r\n                font-weight: 400;\r\n            }\r\n\r\n            ion-label{\r\n                color: #000;\r\n                font-weight: 400;\r\n                font-size: .8em;\r\n            }\r\n\r\n            .item-has-focus .label-floating.sc-ion-label-md-h:not(.ion-color){\r\n                color: #000;\r\n            }\r\n\r\n            .item-interactive.item-has-focus{\r\n                --highlight-background: #000;\r\n            }\r\n\r\n            .forgot{\r\n                width: 100%;\r\n                height: auto;\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n\r\n                a{\r\n                    font-size: .9em;\r\n                    color: #000;\r\n                    font-weight: 400;\r\n                    text-decoration: none;\r\n                    cursor: pointer;\r\n                    margin-top: 0rem;\r\n                    margin-bottom: 0rem;\r\n                    margin: 1.5em 0em;\r\n                    transition: .4s all ease-in-out;\r\n                }\r\n                \r\n                a:hover{\r\n                    color: #14A8CD;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.loginDesk::-webkit-scrollbar {\r\n    width: .35em;\r\n    background-color: transparent;\r\n    height: .7em;\r\n}\r\n  \r\n.loginDesk::-webkit-scrollbar-thumb {\r\n    background-color: #00a2c779;\r\n    //border-radius: 1vh;\r\n    width: 0.25em;\r\n}\r\n\r\n@media(min-width: 992px){\r\n    .loginDesk{\r\n        display: flex;\r\n    }\r\n\r\n    .login-cont-cel{\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
